import {
	BellElectricIcon,
	BellIcon,
	ChartLineIcon,
	DashboardIcon,
	DropletIcon,
	HistoryIcon,
	RadioTowerIcon,
	RouteIcon,
} from '@sailadv/hdata-ui';

import { AppRoutes } from '@/shared/constants/app-routes.constant';

import { NavigationItem } from '../types/navigation-item.interface';

export const navigationList: NavigationItem[] = [
	{
		routes: [
			{
				Icon: DashboardIcon,
				label: 'sidebar.navigation.data.yacht',
				href: AppRoutes.YachtView,
				dynamicHref: ({ singleView }) => singleView,
				dynamicLabel: ({ sidebarSingleView }) => sidebarSingleView,
			},
			{
				Icon: RouteIcon,
				label: 'sidebar.navigation.data.yachtTrack',
				href: AppRoutes.YachtTrack,
				canShow: (isPlant) => !isPlant,
			},
			{ Icon: RadioTowerIcon, label: 'sidebar.navigation.data.virtual', href: AppRoutes.VirtualCockpit },
			{ Icon: HistoryIcon, label: 'sidebar.navigation.data.historical', href: AppRoutes.HistoricalData },
			{ Icon: ChartLineIcon, label: 'sidebar.navigation.data.dashboard', href: AppRoutes.Dashboard },
		],
	},
	{
		title: 'sidebar.navigation.alarm.title',
		routes: [{ Icon: BellElectricIcon, label: 'sidebar.navigation.alarm.management', href: AppRoutes.AlarmManagement }],
	},
	{
		title: 'sidebar.navigation.maintenance.title',
		routes: [
			{
				Icon: BellIcon,
				label: 'sidebar.navigation.maintenance.automated.plan',
				href: AppRoutes.AutomatedPlan,
				canShow: (_, __, automatedPlanAccess) => automatedPlanAccess,
			},
			{ Icon: DropletIcon, label: 'sidebar.navigation.data.oil.analysis', href: AppRoutes.OilAnalysis },
		],
	},
];
